import React from 'react';

import IconWave from '@components/Images/IconWave';
import ListenButton from '@components/ListenButton';
import { ContentType } from '@tracking';

const AudioSection = () => {
  return (
    <article className="relative mx-auto max-w-[900px] border-b border-grayscale-beige pb-80 pt-64 text-center sm:pb-[140px] sm:pt-112">
      <header className="flex flex-col items-center justify-center gap-16 sm:gap-32">
        <div className="pointer-events-none w-full">
          <ListenButton
            isAudioActive={true}
            setIsAudioActive={() => {}}
            contentType={ContentType.Article}
          />
        </div>
        <h2 className="mb-0 mt-8 w-full font-suisse-works text-headline-xxs text-black sm:text-headline-sm md:text-headline-md">
          Listen to Our Articles
        </h2>
      </header>
      <p className="m-0 mx-auto max-w-[560px] font-suisse-neue text-body-lg text-black">
        With our new audio feature, listen to our deep dives and reporting while you multitask.
      </p>
      <small className="mt-8 font-suisse-intl-mono text-overline-md font-normal">
        Available for mobile and desktop
      </small>
      <IconWave className="absolute -bottom-[113px] left-1/2 h-[246px] w-[300px] -translate-x-1/2 text-grayscale-charcoal/10 *:stroke-[2] sm:-bottom-[155px] sm:h-[360px] sm:w-[440px]" />
    </article>
  );
};

export default AudioSection;
